import React from 'react'
import CartItems from '../components/CartItems/CartItems';

function Cart() {
  return (
    <>
    <CartItems/>
    </>
  )
}

export default Cart;